import { indexData } from '@/mocks/homeData';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-folders-line mr-1"></i>内容导航
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按类别浏览所有黑料吃瓜合集，快速找到你感兴趣的爆料内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="group flex items-start gap-4 p-4 md:p-5 bg-background-50 border border-background-200/60 rounded-xl hover:border-primary-300/40 hover:bg-background-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap shrink-0">
                    {item.count}
                  </span>
                </div>
                <p className="mt-1 text-xs md:text-sm text-foreground-500 leading-snug">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}